const state = {
  muteAudio: true,
};

// getters
const getters = {
  muteAudio: state => state.muteAudio,
};

// actions
const actions = {
//   setBpm({ commit }, { bpm }) {
//     commit('setBpm', { bpm });
//     store.dispatch('palettes/updateBpm', { bpm });
//   }
};

// mutations
const mutations = {
  setMuteState(state, { mute }) {
    state.muteAudio = mute;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/audio.js